import React, { CSSProperties, ReactNode } from 'react';

import { Button, CancelButton } from 'components/common';
import { ButtonWrapper } from 'components/common/buttons/ButtonWrapper.styled';
import {
  Backdrop,
  RandomlyPositionedModal,
} from 'components/common/CustomModal/CustomModal.styled';
import { Flex } from 'components/styled/Flex';

interface IRegularModal {
  modalMaxHeight?: string;
  modalMaxWidth?: string;
  modalPadding?: string;
  showModal: boolean;
  cancelBtnLabel?: string;
  handleCancelBtn?: () => void;
  deleteBtnLabel?: string;
  handleDeleteBtn?: () => void;
  isDisabledDeleteBtn?: boolean;
  handleConfirmLabel?: string;
  handleConfirmBtn?: () => void;
  isDisabledConfirmBtn?: boolean;
  isLoading?: boolean;
  backgroundColor?: string;
  children: ReactNode;
  color?: string;
  onHideHandler?: () => void;
  additionalStyle?: CSSProperties;
  backdropBackgroundColor?: string;
  backdropZIndex?: number;
}

export const RegularModal = ({
  modalMaxHeight,
  modalMaxWidth,
  modalPadding,
  showModal,
  cancelBtnLabel,
  handleCancelBtn,
  deleteBtnLabel,
  handleDeleteBtn,
  isDisabledDeleteBtn,
  handleConfirmLabel,
  handleConfirmBtn,
  isDisabledConfirmBtn,
  isLoading,
  backgroundColor,
  children,
  color,
  onHideHandler,
  additionalStyle,
  backdropBackgroundColor,
  backdropZIndex,
}: IRegularModal) => {
  const renderBackdrop = (props: any) => (
    <Backdrop
      {...props}
      backdropBackgroundColor={backdropBackgroundColor}
      zIndex={backdropZIndex}
    />
  );

  return (
    <>
      <RandomlyPositionedModal
        maxHeight={modalMaxHeight}
        maxWidth={modalMaxWidth}
        padding={modalPadding}
        show={showModal}
        onHide={onHideHandler}
        renderBackdrop={renderBackdrop}
        aria-labelledby="modal-label"
        backgroundColor={backgroundColor}
        color={color}
        additionalStyle={additionalStyle}
      >
        <>
          {children}

          {(handleCancelBtn || handleDeleteBtn) && (
            <Flex justifyContent="flex-start" height="100%" alignItems="flex-end">
              <ButtonWrapper>
                {handleCancelBtn && (
                  <CancelButton onClick={handleCancelBtn} label={cancelBtnLabel} />
                )}

                {handleDeleteBtn && (
                  <Button
                    type="reset"
                    color="red"
                    isFetching={isLoading}
                    label={deleteBtnLabel || 'Delete'}
                    onClick={handleDeleteBtn}
                    disabled={isDisabledDeleteBtn}
                  />
                )}

                {handleConfirmBtn && (
                  <Button
                    type="button"
                    color="blue"
                    isFetching={isLoading}
                    label={handleConfirmLabel || 'Save'}
                    onClick={handleConfirmBtn}
                    disabled={isDisabledConfirmBtn}
                  />
                )}
              </ButtonWrapper>
            </Flex>
          )}
        </>
      </RandomlyPositionedModal>
    </>
  );
};
